export default function Footer() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2 lg:col-span-2">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleScroll('#hero');
              }}
              className="flex items-center gap-2 mb-4"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </span>
              <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">
                悟空影视
              </span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-sm">
              悟空影视是国内领先的免费高清影视在线观看平台，海量资源无需注册、即点即播、流畅不缓冲。覆盖电影、电视剧、综艺、动漫、纪录片全品类，每日更新 200+ 内容，满足您所有追剧观影需求。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '热播排行', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '影视索引', href: '#index' },
                { label: '最新动态', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll(link.href);
                  }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">关于我们</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '关于悟空影视', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '常见问题', href: '#faq' },
                { label: '用户评价', href: '#comments' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll(link.href);
                  }}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-500">诚邀优质内容方与品牌方合作</span>
              <span className="text-sm text-background-500">商务联系：敬请期待</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 悟空影视 wukongys.com —— 让好片触手可及
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">服务条款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}